<script>
  export default {
    name: "SelectPill",
    props: {
      value: { type: [String, Number, null], default: null },
      options: {
        type: Array,
        required: true,
        validator(list) {
          return list.every((o) => "label" in o && "value" in o);
        },
      },
      placeholder: { type: String, default: "Seleccionar" },
    },
    data() {
      return {
        open: false,
        localValue: this.value,
      };
    },
    computed: {
      currentOption() {
        return this.options.find((o) => o.value === this.localValue) || null;
      },
      pillStyle() {
        return this.currentOption?.style;
      },
    },
    watch: {
      value(v) {
        this.localValue = v;
      },
    },
    mounted() {
      document.addEventListener("click", this.handleOutside);
    },
    beforeDestroy() {
      document.removeEventListener("click", this.handleOutside);
    },
    methods: {
      handleOutside() {
        if (this.open) this.open = false;
      },
      choose(opt) {
        const previous = this.localValue;
        this.localValue = opt.value;
        this.$emit("input", opt.value);
        this.$emit("change", { value: opt.value, option: opt, previous });
        this.open = false;
      },
    },
  };
</script>

<template>
  <div class="pill-select" @click.stop>
    <button type="button" class="pill-select__pill" :style="pillStyle" :aria-expanded="open" @click="open = !open">
      <span class="pill-select__label">
        {{ currentOption ? currentOption.label : placeholder }}
      </span>
      <span class="pill-select__chev"> <iconic name="arrowNews" class="pill-select__downArrow" /></span>
    </button>

    <div v-if="open" class="pill-select__menu">
      <button v-for="opt in options" :key="opt.value" type="button" class="pill-select__option" :class="{ active: opt.value === localValue }" @click="choose(opt)">
        {{ opt.label }}
      </button>
    </div>
  </div>
</template>

<style lang="scss" scoped>
  .pill-select {
    display: inline-block;
    position: relative;

    &__pill {
      height: 25px;
      width: 95px;
      @include Flex(row, space-between, center);
      gap: 10px;
      padding: 6px 10px;
      font-family: $first_font;
      font-size: 15px;
      border-radius: 50px;
      border: none;
      color: #3d3d3d;
      cursor: pointer;
    }

    &__label {
      text-shadow: 0 0 1px rgba(0, 0, 0, 0.25);
    }

    &__chev {
      @include Flex();
      font-size: 13px;
      padding-bottom: 4px;
      transform: translateY(1px);
    }
    &__downArrow {
      font-size: 11px;
      margin-top: 2px;
    }

    &__menu {
      @include Flex(column);
      gap: 4px;
      position: absolute;
      top: calc(100% + 6px);
      left: 0;
      width: 100%;
      min-width: 80px;
      background: #fff;
      border-radius: 6px;
      box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.25);
      padding: 6px 0;
      z-index: 10;
    }

    &__option {
      @include Flex(column, center, flex-start);
      width: 100%;
      text-align: left;
      border-radius: 4px;
      font-family: $first_font;
      font-size: 15px;
      color: #5b5957;
      cursor: pointer;
      padding: 3px 10px;
      border: 0;
      background: transparent;

      &:hover {
        background: #f4f4f4;
      }

      .active {
        background: #f4f4f4;
      }
    }
  }
</style>
